"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdSetImpressionResponseToJSON = exports.AdSetImpressionResponseFromJSONTyped = exports.AdSetImpressionResponseFromJSON = exports.instanceOfAdSetImpressionResponse = void 0;
var runtime_1 = require("../runtime");
var AdSetImpressionPrediction_1 = require("./AdSetImpressionPrediction");
/**
 * Check if a given object implements the AdSetImpressionResponse interface.
 */
function instanceOfAdSetImpressionResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdSetImpressionResponse = instanceOfAdSetImpressionResponse;
function AdSetImpressionResponseFromJSON(json) {
    return AdSetImpressionResponseFromJSONTyped(json, false);
}
exports.AdSetImpressionResponseFromJSON = AdSetImpressionResponseFromJSON;
function AdSetImpressionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'adSetId': !(0, runtime_1.exists)(json, 'ad_set_id') ? undefined : json['ad_set_id'],
        'impressions': !(0, runtime_1.exists)(json, 'impressions') ? undefined : (0, AdSetImpressionPrediction_1.AdSetImpressionPredictionFromJSON)(json['impressions']),
    };
}
exports.AdSetImpressionResponseFromJSONTyped = AdSetImpressionResponseFromJSONTyped;
function AdSetImpressionResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ad_set_id': value.adSetId,
        'impressions': (0, AdSetImpressionPrediction_1.AdSetImpressionPredictionToJSON)(value.impressions),
    };
}
exports.AdSetImpressionResponseToJSON = AdSetImpressionResponseToJSON;
